

/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-use-before-define */
/* eslint-disable no-unused-vars */

import React, { useCallback, useEffect, useRef, useState, useContext } from 'react'
import { APIEndpoint, DFPAPIEndpoint } from '../../../utils/axios';
import { DataGrid,NGODatePicker,Modal,EditModal} from '../../../common';
import {errorFormatter, formatDateByTimezone,getCultureFromLs,getEndDateMaxLimit,storageUtil} from '../../../utils/commonFunctions';
import OrderListing from './renderers/orderListing';
import { ORDER_SALE_TYPE_LIST_DYNAMIC } from '../../../utils/configs';
import closeIcon from '../../../images/icons/Icon2.png';
import { IoArrowForwardOutline } from "react-icons/io5";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  EventLogContainer,
    InstanceName,
    InstanceStates,
  } from "./renderers";
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import deposit from "../../../assets/deposit.svg";
import DOWNLOAD_ICON from "../../../assets/icons/download-master.svg";
import LoadingGIF from '../../../assets/loadingIn.gif';
import downloadMasterIcon from '../../../assets/icons/download-master.svg';
import SectorInstanceCard from './sectorInstanceCard';
import { useNavigate } from "react-router-dom";
import Select from 'react-select';
import usePermissions from '../../../utils/userPermissions';
import {customSelSearch} from "../../../utils/configs";
import SalesSummary from './renderers/salesSummary';
import {ThemeContext} from '../../../contexts/themeContext';



const EditFormFields = [
    {label: 'Aircraft', attribute: 'aircraft', type: 'multiSelect', disabled: false, options: [], required: true },
    {label: 'Start Date', attribute: 'startDate', type: 'date', disabled: false, required: true },
  ];

export const DynamicPage = (props) => {
  const { t,ready } = useTranslation();
  const savedState = JSON.parse(sessionStorage.getItem('pageStateSynced')) || {emptInst:false,showOrders:false,disabled:false,resetDataSource:false,tailNum:[{key: 0, label: "Select Tail Number", value: ''}]};
  const [state, setState] = useState(savedState);
  const tableRef = useRef();
  const initialRendering=useRef(false);
  const navigate = useNavigate();
  const [perPageLimit, ] = useState(50);
  const [showDownload,setShowDownload]=useState(false);
  const[isLoading,setIsLoading]=useState(false);
  const [buttonId,setButtonId]=useState(null);
  const [searchKey, setSearchKey] = useState('');
  const [reportsType, setReportTypes] = useState([]);
  const [status, setStatus] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [searchKeyOrders, setSearchKeyOrders] = useState("");
  const [saleType, setSaleType] = useState("");
  const [isDropDownOpen,setIsDropdownOpen]=useState(false);
  const [ModalContHeight,setModalContHeight]=useState({height:'auto'})
  const [stores, setStores] = useState([]);
  const [selItemType, setItemType] = useState('');
  const [reptType,setReptType]=useState("");
  const [storeType,setStoreType]=useState("");
  const [saleTypeCheck,setSaleTypeCheck]=useState(false);
  const [orderId,setOrderId]=useState("");
  const [reload,setReload]=useState(0);
  const [ tailNumbers, setTailNumbers ] = useState([])
  const [ aircrafts, setAircrafts ] = useState([])
const [reportDate,setReportDate]=useState({startDate:"",endDate:""});
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [isDownloading, setIsDownloading] = useState(false);
  const {themedColor} = useContext(ThemeContext);
  const { hasPermission: createInstances } = usePermissions('create', 'orn:Account:EditAircraftInstance');
  const { hasPermission: editInstances } = usePermissions('edit', 'orn:Account:EditAircraftInstance');
  const { hasPermission: viewInstances } = usePermissions('viewDetails', 'orn:Account:EditAircraftInstance');
  const { hasPermission: downloadInstances } = usePermissions('download', 'orn:Account:EditAircraftInstance');
  const sType = localStorage.getItem('sType');
  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);

  useEffect( () => {
    fetchAircrafts();

    return () => {
      storageUtil.clear('openSectorId','session');
    }
      }, []);

useEffect(() => {
  if (initialRendering.current === false) {
    initialRendering.current = true;
    return;
  }
  sessionStorage.setItem(
    'pageStateSynced',
    JSON.stringify({
      ...state,
      ...(state.InstanceState !== "excludeNilInstance"
        ? { InstanceState: state.InstanceState }
        : { InstanceState: "" })
    })
  );
}, [state.startDate,state.InstanceState,state.sectors,state.emptInst,state.instanceChange,state.tailNum,state.selected]);
  React.useEffect(() => {
    if(isDropDownOpen){
      setModalContHeight({height:'35vh'})
    }else{
      setModalContHeight({height:'auto'})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isDropDownOpen]);

          useEffect( () => {
            if(state&&state.showOrders){
              fetchOrderDetails();
            }
               }, [saleTypeCheck,saleType,status,paymentType,searchKeyOrders]);

          useEffect( () => {
          setIsDownloading(false)
            }, [reptType]);

              const showToast = (msg) => {
                toast.dismiss();

               if (msg.error) {
                  toast.error(msg.error, {
                    position: toast.POSITION.TOP_CENTER,
                    hideProgressBar: true,
                    pauseOnHover: true,
                    draggable: false,
                    autoClose: 3800,
                    style: {
                      backgroundColor: '#d9534f',
                      color: '#fff',
                      borderRadius: '8px',
                      fontSize: '1rem',
                      width:'30rem'
                    }
                  });
                } else {

                }
              };


    const InstanceState=[{id:1,label:'Active',value:'open'},{id:2,label:'Locked',value:'locked'},{id:3,label:'Commit Scheduled',value:'commitScheduled'},{id:4,label:'Committed',value:'committed'},{id:5,label:'Exclude Empty Instances',value:'excludeNilInstance'}]
const fetchOrderDetails=async()=>{
  const filterData={
    page: 1,
    limit: 50,
    source: "isolate"
}

  let filters = [ {
    "sectorId": orderId,
    "sortBySaletype": saleTypeCheck
}];

  const filterConditions = [
    { condition: status, filter: {status } },
    { condition: saleType, filter: { saleType } },
    { condition: paymentType, filter: { paymentType } },
    { condition: searchKeyOrders, filter: { searchKey:searchKeyOrders } },
  ];


  filterConditions.forEach(({ condition, filter }) => {
    if (condition) {
      const existingFilterIndex = filters.findIndex(existingFilter => {
        return Object.keys(existingFilter).every(key => filter.hasOwnProperty(key));
      });

      if (existingFilterIndex !== -1) {
        const existingFilter = filters[existingFilterIndex];
        filters[existingFilterIndex] = { ...existingFilter, ...filter };
      } else {
        filters.push(filter);
      }
    }
  });
  filterData.filters = filters;

  try {
    const res = await APIEndpoint.post(`sandboxing/isolatedOrders/listing`,filterData);
   if(res.count){
   setState((prev)=>({
  ...prev,
  showOrders:true,
  selected2:{
    ...prev.selected2,
    action:'orders',
    data:res?.items
  }
}))
   }else{
   setState((prev)=>({
  ...prev,
  showOrders:true,
  selected2:{
    ...prev.selected2,
    action:'orders',
    data:res?.items
  }
}))

   }
 }
 catch (error) {


 }

}


const sectorTitle=()=>{
  const {action}=state.selected2?state.selected2:state.selected;
  if(action==='sectorAttachments'||action==='viewEventLogs'){
    const { selected = state.selected2 } = state;
return(<div className='flexRow justifyContentCenter'>
  <div className='flexRow'>
    {action==='sectorAttachments'?<div className='flexRow justifyContentCenter alignItemsCenter'>Sector attached to instance -<div className='instance-member-name'>{selected.name}</div>
    <button
      className='small-body-text-regular fontExtrabold key-value btn-sync'
      type="button"
      aria-label="Refresh sectors"
      onClick={() => setReload(_ => _ + 1)}
    >
      <img style={{height:'40px',width:"40px",backgroundColor:"#4c5c81",borderRadius:"4px"}} src={deposit} alt='refresh-sectors' />
      </button>
    </div>:<div className='flexRow'>Event Log-<div className='instance-member-name'>{(state?.selected&&state?.selected.data)?state?.selected?.data[0]?.target.name:state?.selected2.data[0]?.target.name}</div></div>}

  </div>
</div>)
  } else if(action==='uplifts'){
    const {selected2}=state;
    return(<div className='flexRow justifyContentCenter'>
      <div className='flexRow'>
        <div className='flexRow justifyContentCenter alignItemsCenter'>Uplift from <div className='instance-member-name'>{selected2.data?.warehouse?.warehouseCode}</div></div>

      </div>
    </div>)
  }
  else if(action==='orders'){
    const { name } = state.data?.transferOutReport?.sector || state?.flightDetails || {};
return (
<div className='flexRow justifyContentSpaceBetween alignItemsCenter content-tabs'>

  <div className='flexRow justifyContentFlexStart content-tabs' style={{ marginRight: "auto" }}>
    <div className='flexRow dialog__description__checkbox alignItemsCenter'>
      <input
        id="saleTypeCheck"
        type="checkbox"
        onClick={() => setSaleTypeCheck(!saleTypeCheck)}
        checked={saleTypeCheck}
        value={saleTypeCheck}
      />
      <label
        htmlFor="saleTypeCheck"
        className='margTop8'
        style={{ fontSize: "1rem", fontWeight: "bold" }}
      >
        Sort By SaleType
      </label>
    </div>
  </div>

  <div className='flexRow content-tabs alignItemsCenter'>
    <div className='flexRow justifyContentCenter alignItemsCenter'>
      Orders -
      <div className='instance-member-name'>{name || 'None'}</div>
    </div>

    <button
      className='small-body-text-regular fontExtrabold key-value btn-sync'
      type="button"
      aria-label="Refresh orders"
      onClick={() => setReload(_ => _ + 1)}
    >
      <img
        style={{
          height: "40px",
          width: "40px",
          backgroundColor: "#4c5c81",
          borderRadius: "4px"
        }}
        src={deposit}
        alt="refresh-sectors"
      />
    </button>
  </div>

</div>
)
  }
  else if(action==='stockMovement'){
    const { name } = state.data?.transferOutReport?.sector || state.selected2?.flightDetails || {};

    return(<div className='flexRow justifyContentCenter'>
      <div className='flexRow'>
        <div className='flexRow justifyContentCenter alignItemsCenter'>Stock movement -<div className='instance-member-name'>{name}</div></div>
      </div>
    </div>)
  }
  else if(action==='transferOut'){
    const { name } = state.data?.transferOutReport?.sector || {};

    return(<div className='flexRow justifyContentCenter'>
      <div className='flexRow'>
        <div className='flexRow justifyContentCenter alignItemsCenter'>Transfers -<div className='instance-member-name'>{name}</div></div>
      </div>
    </div>)
  }
  else if(action==='transferIn'){

    const { name } = (state.data?.transferInReport?.sector || state.selected2?.flightDetails) ?? {};


    return(<div className='flexRow justifyContentCenter'>
      <div className='flexRow'>
        <div className='flexRow justifyContentCenter alignItemsCenter'>Transfers-<div className='instance-member-name'>{name}</div></div>
      </div>
    </div>)
  }
  else if(action==='upliftAudit'){
    const { name } = state.data?.upliftAuditReport?.sector ?? {};



    return(<div className='flexRow justifyContentCenter'>
      <div className='flexRow'>
        <div className='flexRow'>Uplift Audit Report -<div className='instance-member-name'>{name}</div></div>
      </div>
    </div>)
  }

  else if(action==='salesSummary'){
    const { name } = state?.data?.name !== undefined ? state.data : state?.selected2?.flightDetails ?? {};

    return(<div className='flexRow justifyContentCenter'>
      <div className='flexRow'>
        <div className='flexRow'>Sales summary -<div className='instance-member-name'>{name}</div></div>
      </div>
    </div>)
  }
  else{
    return(<></>)
  }

}
  const fetchAircrafts = useCallback(
    async () => {
      try {
             const resp = await DOMAIN.get('sandboxing/aircrafts');
      if (resp.result.length ) {
            const options1 = [];
            resp.result.filter( (fieldValue, index) => {
              options1.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
              return fieldValue;
            });
       setTailNumbers(options1)

       const options2 = [{key: 0, label: "Select Aircraft", value: ''}];
       resp.result.filter( (fieldValue, index) => {
         options2.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
         return fieldValue;
       });
      setAircrafts(options2)
      }
      else {
      }
      } catch (error) {

      }

    },
    [],
  )

  const getRowHeight = (params) => {
    const numSectors = params?params.length : 0;
    return 85 + numSectors * 20;
  };

  const onClickSectorInsAttach=async(data)=>{
    setState( (_prev) => {
      return { ..._prev, selected: {...data,  action: 'sectorAttachments' },selected2:false,resetDataSource:false}
    });

  }

  const showEventLogs=async(event,obj)=>{
  const submitBtnObj = document.querySelector(".status-dynamic.dynamic-sl");
  submitBtnObj?.setAttribute("disabled", "true");
    const {id}=event;

    const filterData={
      "page": 1,
      "limit": 50,
      "filters": []
  }


    try {
      const res = await APIEndpoint.post(`sandboxing/isolatedSectors/${id}/events`,filterData);
      if (res.items) {
        setState((prev)=>({...prev,selected2:{action:'viewEventLogs',data:res.items}}))
      }
    } catch (error) {
    }finally {
    submitBtnObj?.removeAttribute("disabled");
  }
  }



  const SectorsCellRenderer = (props) => {
    const {value,data}=props;
    if(value && value.length){
       const uniqueSectors = [...new Set(value.map(sector => sector.key))];
    return (
        <><div className='flexRow justifyContentSpaceBetween' style={{width:'100%',maxWidth:'235px',overflow:'auto'}}>
        <div className='sector-container justifyContentFlexStart alignItemsCenter' style={{maxWidth:'200px'}}>{uniqueSectors.length > 0 ? uniqueSectors.map((key, index) => (
        <span key={index} title={key} className={!index?"sector-label-minGrid margSecotInit":"sector-label-minGrid"}>{key.split("/")[0]||null}</span>
        )) : "None"}</div>
        { editInstances && viewInstances && <div className='sector-container margRight' style={{position:'absolute',right:0}}>
        {props && data &&
        <span onClick={()=>onClickSectorInsAttach(data)} className="sector-button-operations">...</span>
        }
        </div>}
        </div>
        </>
    );
    }else if(Array.isArray(value) && !value.length){
      return (
        <div className='sector-container'>
          None
        </div>)
    }
    else{
      return (
        <div className='sector-container'>

        </div>)
    }
  };

const paymentTypeDist=[
  { field: 'paymentType',headerName: 'Payment Type',valueGetter: (params) => {
    if (params.data&&params.data.paymentType) {
       return params.data.paymentType==='none'?"SSR":params.data.paymentType.charAt(0).toUpperCase()+params.data.paymentType.slice(1)
    }
    return null;
  }, flex:1, suppressSizeToFit:true, resizable:true, minWidth: 155},
  { field: 'totalNumberOfOrders',headerName: 'Number of Orders', flex:1, suppressSizeToFit:true, minWidth: 100 },
  { field: 'amount',headerName: `Amount (${getCultureFromLs()?.currency?.code})`, flex:1, suppressSizeToFit:true, minWidth: 100 },
]

const saleTypeDist=[
  { field: 'saleType',headerName: 'Sale Type', flex:1, suppressSizeToFit:true,valueGetter: (params) => {
    if (params.data&&params.data.saleType) {
       return ORDER_SALE_TYPE_LIST_DYNAMIC.find(ord=>ord.value===params.data.saleType)?.label
    }
    return null;
  },   minWidth: 155 },
  { field: 'totalNumberOfOrders',headerName: 'Number Of Orders', flex:1, suppressSizeToFit:true, minWidth: 100 },
  { field: 'amount',headerName:  `Amount (${getCultureFromLs()?.currency?.code})`, flex:1, suppressSizeToFit:true, minWidth: 100 },
]
const currencyDist=[
  { field: 'code',headerName: 'Currency', flex:1, suppressSizeToFit:true, minWidth: 155 },
  { field: 'totalNumberOfOrders',headerName: 'Number of Orders', flex:1, suppressSizeToFit:true, minWidth: 100 },
  { field: 'amount',headerName: 'Amount', flex:1, suppressSizeToFit:true, minWidth: 100 },
]

const TransferIn=[
  { field: 'itemCode',headerName: 'Item Code', flex:1,tooltipField:'itemCode',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, suppressSizeToFit:true,resizable:true, minWidth: 155 },
  { field: 'itemName',headerName: 'Item Name',tooltipField: 'itemName',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, flex:1, suppressSizeToFit:true,resizable:true, minWidth: 155 },
  { field: 'quantity',headerName: 'Quantity', flex:1, suppressSizeToFit:true, minWidth: 100 },
  { field: 'unit',headerName: 'Unit', flex:1, suppressSizeToFit:true, minWidth: 100 },
]

const UpliftAudit=[
  { field: 'itemCode',headerName: 'Item Code', flex:1,tooltipField:'itemCode',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, suppressSizeToFit:true, resizable:true, minWidth: 125 },
  { field: 'itemName',headerName: 'Item Name',tooltipField: 'itemName',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, flex:1, suppressSizeToFit:true, resizable:true, minWidth: 155,},
  { field: 'reportedQuantity',headerName: 'Reported Quantity', flex:1, suppressSizeToFit:true, minWidth: 100 },
  { field: 'actualQuantity',headerName: 'Actual Quantity', flex:1, suppressSizeToFit:true, minWidth: 100 },
  {field:'',headerName:'Variance',flex:1,suppressSizeToFit:true,valueGetter: (params) => {
    if (params.data && typeof params.data.reportedQuantity ==='number' && typeof params.data.actualQuantity==='number') {
       return Number(params.data.actualQuantity)- Number(params.data.reportedQuantity)
    }
    else{
      return null;
    }
  },cellStyle: (params) => {
    if (params.data && typeof params.data.reportedQuantity ==='number' && typeof params.data.actualQuantity==='number') {
     let varNum= Number(params.data.actualQuantity)- Number(params.data.reportedQuantity);
     if(varNum>0){
      return { color: '#47d26c',fontWeight:'bold' };

     }else if(varNum<0){
      return { color: '#f06547',fontWeight:'bold' };
     }else{
      return;
     }
    }else{
      return null
    }

  },
  minWidth: 100},
  {field:'unit',headerName:'Unit',flex:1,suppressSizeToFit:true,minWidth: 100}
]

const Uplifts=[
  { field: 'itemCode',headerName: 'Item Code', flex:1,tooltipField:'itemCode', suppressSizeToFit:true, resizable:true, minWidth: 125,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, },
  { field: 'itemName',headerName: 'Item Name', tooltipField: 'itemName',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },flex:1, suppressSizeToFit:true, resizable:true, minWidth: 100 },
  { field: 'bob',headerName: 'BoB', flex:1, suppressSizeToFit:true, minWidth: 100 },
  { field: 'corporate',headerName: 'Corporate', flex:1, suppressSizeToFit:true, minWidth: 100 },
  { field: 'webMeal',headerName: 'Pre-booked', flex:1, suppressSizeToFit:true, minWidth: 100 },
  { field: 'total',headerName: 'Total', flex:1, suppressSizeToFit:true, minWidth: 100 },
  { field: 'unit',headerName: 'Unit', flex:1, suppressSizeToFit:true, minWidth: 100 }
]



const StockMvmnt=[
  { field: 'itemCode',headerName: 'Item Code', flex:1, tooltipField:'itemCode',suppressSizeToFit:true, resizable:true, minWidth: 125 ,cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  },},
  { field: 'itemName',headerName: 'Item Name', flex:1,tooltipField: 'itemName',cellStyle: {
    whiteSpace: 'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
  }, suppressSizeToFit:true, resizable:true, minWidth: 165 },
  { field: 'openingStock',headerName: 'Opening Stock', flex:1, suppressSizeToFit:true,  minWidth: 100 },
  { field: 'uplift',headerName: 'Uplift', flex:1, suppressSizeToFit:true,  minWidth: 100 ,valueGetter: (params) => {
    if (params.data && params.data.uplift) {
       return params.data.uplift
    }else{
      return 0;
    }
  },},
  { field: 'transferIn',headerName: 'Transfer In',valueGetter: (params) => {
    if (params.data&&params.data.transferIn) {
       return params.data.transferIn
    }else{
      return 0;
    }
  }, flex:1, suppressSizeToFit:true,  minWidth: 100 },
  { field: 'variance',headerName: 'Variance',valueGetter: (params) => {
    if (params.data&&params.data.variance) {
       return params.data.variance
    }else{
      return 0;
    }
  }, flex:1, suppressSizeToFit:true,  minWidth: 100 },
  { field: 'cancelOrder',headerName: 'Wastage', valueGetter: (params) => {
    if (params.data&&params.data.cancelOrder) {
       return params.data.cancelOrder
    }else{
      return 0;
    }
  },flex:1, suppressSizeToFit:true,  minWidth: 100 },
  { field: 'cancelOrder',headerName: 'Wastage (from POS)',valueGetter: (params) => {
    if (params.data&&params.data.cancelOrder) {
       return params.data.cancelOrder
    }else{
      return 0;
    }
  }, flex:1, suppressSizeToFit:true,  minWidth: 100 },
  { field: 'offload',headerName: 'Offload',valueGetter: (params) => {
    if (params.data&&params.data.offload) {
       return params.data.offload
    }else{
      return 0;
    }
  }, flex:1, suppressSizeToFit:true,  minWidth: 100 },
  { field: 'placeOrder',headerName: 'Order', valueGetter: (params) => {
    if (params.data&&params.data.placeOrder) {
       return params.data.placeOrder
    }else{
      return 0;
    }
  },flex:1, suppressSizeToFit:true,  minWidth: 100 },
  { field: 'transferOut',headerName: 'Transfer Out',valueGetter: (params) => {
    if (params.data&&params.data.transferOut) {
       return params.data.transferOut
    }else{
      return 0;
    }
  }, flex:1, suppressSizeToFit:true,  minWidth: 100 },
  { field: 'closingStock',headerName: 'Closing Stock', valueGetter: (params) => {
    if (params.data&&params.data.closingStock) {
       return params.data.closingStock
    }else{
      return 0;
    }
  },flex:1, suppressSizeToFit:true,  minWidth: 100 },
  { field: 'unit',headerName: 'Unit', flex:1, suppressSizeToFit:true, minWidth: 100 },

]

  const Columns = [
    { field: 'name',headerName: 'Instance Name', flex:1,suppressSizeToFit:true, resizable:true, minWidth: 200,pinned:'left', cellRendererSelector: (params) => {
        return {
          component: InstanceName,
        };
      },cellStyle: {
        whiteSpace: 'nowrap',
        overflow:'hidden',
        textOverflow:'ellipsis',
      } },
    { field: 'aircraft',headerName: 'Tail Number',  flex:1,suppressSizeToFit:true, resizable:true, minWidth: 80,
      tooltipField:"aircraft.aircraftNumber",  valueGetter: (params) => {
        if (params.data&&params.data.aircraft) {
           return params.data.aircraft.aircraftNumber?params.data.aircraft.aircraftNumber:"";
        }
        return null;
      },
    },
    { field: 'startDate', headerName: 'Start Date',minWidth:110,valueGetter: params => {
      return params.data?.startDate ? moment.parseZone(formatDateByTimezone(params.data?.startDate)).format('DD-MM-YYYY') : '';
  },suppressSizeToFit:true,flex:1 },
    { field: 'createdAt',headerName: 'Created At',minWidth:160,valueGetter: params => {
      return params.data?.createdAt ? moment(params.data?.createdAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A') : '';
  }, flex:1,suppressSizeToFit:true},
    { field: 'state',headerName: 'Instance State',minWidth:110, cellRendererSelector: (params) => {
        return {
          component: InstanceStates,
        };
      }, flex:1,suppressSizeToFit:true },
    { field: 'sectors',headerName: 'Sectors',cellRendererFramework: SectorsCellRenderer, cellRendererParams: {
      someOtherProp: props?.data,cellStyle: {
        whiteSpace: 'nowrap',
        overflow:'hidden',
        textOverflow:'ellipsis',
      }
    },flex:1,suppressSizeToFit:true, minWidth: 295},
    {
      headerName:'Actions',
      pinned:'right',
       autoResize:true,
        width:130,
        maxWidth:145,
        resizable: false,
        suppressSizeToFit:true,
        cellRenderer: actionsDynamic,
        valueGetter: function(params) {
          return params;
        },
        headerClass: 'actions-header',
      }
  ];

  const handleReset = () => {
    setState((_) => {
      return { ..._, resetDataSource:!state.resetDataSource,disabled:false};
    })
    let timerId = setTimeout(() => {
      clearTimeout(timerId);
    setModalFormStatusObj({ text:""});
      handleModalCancel();
    }, 1000)
  }
  const filterData = {action: 4, filters: [], limit: 50, page: 1, sort: [{field: "startDate", order: "desc"}]}
  const setSector = (data,type) => {
    const {id,name} = data;
    if(type==='details'){
      const encodedName = encodeURIComponent(name);
      navigate(`/sales/dynamic/sector/containerIsolate/${encodedName}/${id}`,{state: { id, name }});
    }


  };


 const customStyles = {
      input: (defaultStyles) => ({
        ...defaultStyles,
        color: '#fff',
      }),
      control: (defaultStyles) => ({
        ...defaultStyles,
        backgroundColor: themedColor.background,
        padding: "2px",
        width: '17rem',
        marginTop: '0.5rem',
        border: "0.4px solid #FFFFFF",
        boxShadow: "none",
      }),
      option: (defaultStyles) => ({
        ...defaultStyles,
        color: '#fff',
        backgroundColor: themedColor.background,
        textAlign: 'left',
      }),
      singleValue: (defaultStyles) => ({
        ...defaultStyles,
        color: '#fff',
      }),
      placeholder: (defaultStyles) => ({
        ...defaultStyles,
        textAlign: 'left',
      })
    };
const getVarianceReport=async(inst)=>{

  const {id}=inst;
  setButtonId(id);
  const button = document.getElementById(id);

  const data= {
      reportType: "bifurcatedReconReport",
      id: id
  }
  const header={
    ...APIEndpoint.getHeaders().headers,
    'Accept':'text/csv',
  };

  try {
    if (button) {
      setIsLoading(true);
    }

    const res = await DOMAIN.post('sales/reports', data, header);

    if (res.status === 'scheduled') {
      setTimeout(async () => {
        try {
          const dowId = await DOMAIN.get(`downloads/status/${res.id}`);
          if (dowId.status === "completed") {
            DOMAIN.get(`downloads/analytics/${dowId.fileName}${dowId.fileExtension}`)
              .then((ItemMasterDwnld) => {
                const url = window.URL.createObjectURL(new Blob([ItemMasterDwnld]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', dowId.fileName + dowId.fileExtension);
                document.body.appendChild(link);
                link.click();

                if (button) {
                  setIsLoading(false);
                }
              })
              .catch((error) => {
                if (button) {
                  setButtonId(null);
                  setIsLoading(false);
                }
              });
          }
          if(dowId?.data && !dowId?.data.success ){
            const {message}=dowId.data;
            showToast({error:message})
            setIsLoading(false);
            setButtonId(null);
          }
        } catch (error) {
          if (button) {
            setButtonId(null);
            setIsLoading(false);
          }
        }
      }, 3000);
    }
  } catch (error) {
    if (button) {
      setIsLoading(false);
      setTimeout(() => {
        setButtonId(null);
      }, 1000);
    }
  }


}


  function actionsDynamic(props){
    return (
      props.data?
          <div className='flexRow margTop5'>
       {props.data&&props.data?.state!=='committed'? <><div className='icon-aircraft-container'>
        <button className="grid-download-btnStyle1" onClick={(e) => setSector(props.data, 'details')}>Details</button>
        </div>
    </>:<>
        <div className='icon-aircraft-container flexRow justifyContentSpaceBetween'>
        <button className="grid-download-btnStyle1" onClick={(e) => setSector(props.data, 'details')}>Details</button>
        </div>
        {isLoading && buttonId === props.data.id ? (
                  <img
                    src={LoadingGIF}
                    className="icon-size"
                    style={{ width: '25px', height: '24px'}}
                    alt="Loading"
                  />
                ) : (

                    <button
                      id={props.data.id}
                      disabled={isLoading}
                      className="margRight"
                      style={{ cursor: 'pointer' }}
                      title={"Download Variance"}
                      onClick={() => getVarianceReport(props.data)}
                    >
                      <img src={DOWNLOAD_ICON} className="node-icon svg" alt="" />
                    </button>
                  )
                }


        </>}
      </div>
         : <></>
    );
  }

  const fetchOperationsPanel = async (page=1, perPage=50) => {

    const startDateF = state.startDate?formatDateByTimezone(state.startDate): moment(state.startDate).format('YYYY-MM-DDTHH:mm:ssZ');
    filterData.page = page;
    filterData.limit = perPage;
    filterData.searchParam = searchKey;

    if (state) {
      let filters = [];
      const dynStates={...state,...(state.InstanceState!=="excludeNilInstance"?{InstanceState:state.InstanceState}:{InstanceState:""})};

      const filterConditions = [
        { condition: dynStates.emptInst, filter: { excludeEmptyIsolates: true } },
        { condition: dynStates.instanceChange, filter: { name: dynStates.instanceChange } },
        { condition: dynStates.tailNum, filter: { aircraftId: dynStates.tailNum[0]?.value||null } },
        { condition: dynStates.startDate, filter: { startDate: startDateF } },
        { condition: dynStates.InstanceState, filter: { state: dynStates.InstanceState } },
        { condition: dynStates.sectors, filter: { sectors: dynStates.sectors } }
      ];


      filterConditions.forEach(({ condition, filter }) => {
        if (condition) {
          const existingFilterIndex = filters.findIndex(existingFilter => {
            return Object.keys(existingFilter).every(key => filter.hasOwnProperty(key));
          });

          if (existingFilterIndex !== -1) {
            const existingFilter = filters[existingFilterIndex];
            filters[existingFilterIndex] = { ...existingFilter, ...filter };
          } else {
            filters.push(filter);
          }
        }
      });
      filterData.filters = filters;
    }
    try {
      const res = await DOMAIN.post('sandboxing/containerIsolates/listing', JSON.stringify(filterData));
      return res;
    } catch (error) {

    }

  }

  const inventoryDetails = async(data,index=null,type,editDocDetails=null,obj)=>{

  setOrderId(data.id)
if(type==='uplifts'){
    const submitBtnObj = document.querySelector(".status-dynamic");
  submitBtnObj?.setAttribute("disabled", "true");
const {id}=data?.uplifts[index];
try {
  const res = await APIEndpoint.get(`sandboxing/uplifts/${id}`);

 if(res && res.uplift){
  setState((prev)=>({...prev,data,flightDetails:obj,selected2:{flightDetails:{...res.uplift,...res.uplift.sector},action:type,data:res?.uplift}}))
 }
}
catch (error) {


}finally {
    submitBtnObj?.removeAttribute("disabled");
  }
}

else if(type==='transferIn'|| type==='upliftAudit'){
        const submitBtnObj = document.querySelector(".status-dynamic");
  submitBtnObj?.setAttribute("disabled", "true");
  const { id } = data?.transferInReport ?? data?.upliftAuditReport ?? data ?? {};

  try {
    const res = await APIEndpoint.get(`sandboxing/inventoryReports/${id}`);

   if(res){
    setState((prev)=>({...prev,data,flightDetails:obj,selected2:{flightDetails:obj,action:type,data:res?.inventoryReport}}))
   }
 }
 catch (error) {


 }finally {
    submitBtnObj?.removeAttribute("disabled");
  }

}else if(type==='salesSummary'){
    const submitBtnObj = document.querySelector(".status-dynamic.dynamic-sl");
  submitBtnObj?.setAttribute("disabled", "true");
   const {id}=data;
  try {
    const res = await APIEndpoint.get(`sandboxing/isolatedSectors/${id}/salesSummary`);
   if(res){
    setState((prev)=>({...prev,data,flightDetails:obj,selected2:{flightDetails:obj,action:type,data:res?.salesSummary}}))
   }
 }
 catch (error) {


 }finally {
    submitBtnObj?.removeAttribute("disabled");
  }


}
else if(type==='transferOut'){
  const submitBtnObj = document.querySelector(".status-dynamic.dynamic-act");
  submitBtnObj?.setAttribute("disabled", "true");

  const {id}=data?.transferOutReport;
  try {
    const res = await APIEndpoint.get(`sandboxing/inventoryReports/${id}`);
   if(res){
    setState((prev)=>({...prev,data,flightDetails:obj,selected2:{flightDetails:obj,action:type,data:res?.inventoryReport}}))
   }
 }
 catch (error) {


 }finally {
    submitBtnObj?.removeAttribute("disabled");
  }


}
else if(type==='orders'){
  const submitBtnObj = document.querySelector(".status-dynamic.dynamic-act");
  submitBtnObj?.setAttribute("disabled", "true");
  const filterData={
    page: 1,
    limit: 50,
    source: "isolate"
}

  let filters = [ {
    "sectorId": data.id,
    "sortBySaletype": saleTypeCheck
}];

  filterData.filters = filters;

  try {
    const res = await APIEndpoint.post(`sandboxing/isolatedOrders/listing`,filterData);
   if(res.count){
    setState((prev)=>({...prev,data,showOrders:true,flightDetails:obj,selected2:{flightDetails:obj,action:type,data:res?.items}}))
   }
   else{
    setState((prev)=>({...prev,data,showOrders:true,flightDetails:obj,selected2:{flightDetails:obj,action:type,data:res?.items}}))

   }
 }
 catch (error) {


 }finally {
    submitBtnObj?.removeAttribute("disabled");
  }


}
else {
    const submitBtnObj = document.querySelector(".status-dynamic.dynamic-sl");
  submitBtnObj?.setAttribute("disabled", "true");
  const {id}=data;
  try {
    const res = await APIEndpoint.get(`sandboxing/isolatedSectors/${id}/inventorySnapshot`);
  if (res?.inventorySnapshot?.items) {
      const items = res.inventorySnapshot.items;

      const sortedItems = [...items].sort((a, b) => (a.closingStock ?? 0) - (b.closingStock ?? 0));

      setState((prev) => ({...prev,selected2: {flightDetails: obj,action: type,data: {...res.inventorySnapshot,items: sortedItems}}}));
    }
 }
 catch (error) {


 }finally {
    submitBtnObj?.removeAttribute("disabled");
  }


}

  }
const onDownloadActivityReport=async()=>{
  let header={
    'Accept':'text/csv'
  }
    try {
    const res= await DOMAIN.post(`devices/activityReport`,{},header);
    if(res.status==='scheduled'){
      setTimeout(() => {
        setIsDownloading(true)
        const sapRep=APIEndpoint.get('downloads/status/'+ res.id)
        sapRep.then((val) => {
          if (val.status === "completed") {
              DOMAIN.get(`downloads/analytics/${val.fileName}${val.fileExtension}`)
                  .then((ItemMasterDwnld) => {
                      const url = window.URL.createObjectURL(new Blob([ItemMasterDwnld]));
                      const link = document.createElement('a');
                      link.href = url;
                      link.setAttribute('download', `${val.fileName}${val.fileExtension}`);
                      document.body.appendChild(link);
                      link.click();
                      setIsDownloading(false)
                  })
                  .catch((error) => {

                      console.error('Error downloading CSV:', error);
                      setIsDownloading(false);
                  });
                  setState((_prev) => {
                    return { ..._prev, selected: false };
                });
                setModalFormStatusObj({ text: '' });
          }
      });
        }, 8000);
    }
    }
     catch (error) {
      setState((_) => {
        return { ..._,message:{text:error?.data?.message},};
      })
      setTimeout(() => {
        setState((prevState) => ({
          ...prevState,
          message: null,
        }));
      }, 5000);
       setIsDownloading(false)
     }
  }

  const handleCreateInstance=async(e,updated)=>{
if(updated){
  setState((prev)=>({...prev,disabled:true}))

   try {
    const res = await APIEndpoint.post(`sandboxing/containerIsolates`,{aircraftId:tailNumbers.find(aId=>aId.label===updated.aircraft)?.value,startDate:updated.startDate});
   if(res.message){
    setModalFormStatusObj({ text: res.message });
    handleReset();
   }
 }
 catch (error) {
  let {data}=JSON.parse(error.message)

  if(data?.errors && data?.errors[0]?.message.length){
   let errorMessageFormatted= errorFormatter(data?.errors[0]?.message)
  setModalFormStatusObj({ error: errorMessageFormatted });

  }else if(data?.message){
    setModalFormStatusObj({error:data.message})
  }else{
  setModalFormStatusObj({ error: "Error creating Instance" });
  }
  setState((prev)=>({...prev,disabled:false}))

 }
}else{
  setModalFormStatusObj({error:'Please provide the necessary fields.'})
}

  }

  const handleModalCancel=(modal=null)=>{
   setState((prev)=>({...prev,selected:false,disabled:false}))
   setIsDropdownOpen(false);
   setModalFormStatusObj({ text:""});
   if(modal==='SectAttach'){
    sessionStorage.removeItem('sectorsDynm');
    sessionStorage.removeItem('secISoDynamic');
   }

  }

  const handleModalCancelEvent=()=>{

    setState((_) => {
      const modState = { ..._ };
      delete modState.selected2;
      return modState;
    });
    setModalFormStatusObj({ text:""});
   }

 const onDownloadReport=async()=>{
  if(reptType==='activityReport'){
    setIsDownloading(true);
    onDownloadActivityReport();
  }
  else{
    if(!reportsType.length|| !stores.length){
      try {
      const resp = await DOMAIN.get('reports/sandboxReportTypes');
      if (resp.result.length > 0 && !reportsType.length) {
          const options = [{key: 0, label: "Select Report Type", value: ''},{key:1,label: "Activity Report", value: 'activityReport'}];
          resp.result.filter( (fieldValue, index) => {
            options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
            return fieldValue;
          });
          setReportTypes(options);
      }
     
      const respStore = await DOMAIN.get('stores');
      if (respStore.result.length > 0 && !stores.length) {
          const options = [{key: 0, label: "Select Route", value: ''}];
          respStore.result.filter( (fieldValue, index) => {
            options.push({key: index+1, storeId:fieldValue.id,label: `${fieldValue.flightNumber} (${fieldValue.originName}-${fieldValue.destinationName})`, value: `${fieldValue.value}`});
            return fieldValue;
          });
          setStores(options);
      }
  } catch (error) {
  
  }
    }

setShowDownload(true)
let body={}
if(reportDate.startDate  && reportDate.endDate  && reptType){
   body = {
  startDate: formatDateByTimezone(new Date(reportDate.startDate),true),
  endDate: formatDateByTimezone(new Date(reportDate.endDate),true),
  reportType: reptType,
  ...(storeType.length > 0 ? { storeId:storeType[0]?.storeId.toString() } : {})
  };
 let header={
      'Accept':'text/csv'
    }
        try {
        const res= await DOMAIN.post(`sales/reports`,body,header);
        if(res.status==='scheduled'){
                checkDownloadStatus(res.id,null);

        }
        }
         catch (error) {
          setState((_) => {
            return { ..._,message:{text:error?.data?.message},};
          })
          setTimeout(() => {
            setState((prevState) => ({
              ...prevState,
              message: null,
            }));
          }, 5000);
           setIsDownloading(false)
         }
}

  }



      }

      const checkDownloadStatus = async (dowId, e) => {

        let timeout=null;
          setIsDownloading(true)
        await APIEndpoint.get('downloads/status/'+ dowId).then( resp => {
          if (resp.status === 'completed') {
            setTimeout(() => {
             const dowIdRes= DOMAIN.get(`downloads/status/${dowId}`);
          dowIdRes.then((val) => {
            if (val.status === "completed") {
                DOMAIN.get(`downloads/analytics/${val.fileName}${val.fileExtension}`)
                    .then((userAccountDownload) => {
                        const url = window.URL.createObjectURL(new Blob([userAccountDownload]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', `${val.fileName}${val.fileExtension}`);
                        document.body.appendChild(link);
                        link.click();
                        setIsDownloading(false);
                    })
                    .catch((error) => {

                        console.error('Error downloading CSV:', error);
                        setIsDownloading(false);
                    });
                  setState((_prev) => {
                  return { ..._prev, selected: false };
                  });
                  setIsDownloading(false);
                  setModalFormStatusObj({ text: '' });
            }
        });       
              }, 2000);


            }
            else {
                clearTimeout(timeout);
                 timeout = setTimeout(() => {
                    checkDownloadStatus(dowId, e);
                }, 5000);
            }

        }).catch( error => {

        });
    };

  const onAddItemHandler = () => {

    /**
     * Set to edit form
     */
     EditFormFields.forEach( editRow => {

      if(editRow.attribute === 'aircraft'){
        editRow.options=aircrafts;
      }
      return editRow;
    });
    if(EditFormFields.length){
    setState( (_prev) => {return { ..._prev, selected:'createInstance'}});

    }
  }

  const onReportTypeChange = (e) => {
    setReptType(e.target.value);
}
const onStoreChange=(e)=>{
    if(reptType==="sandboxSalesSummary"||reptType==="sandboxInvoiceSummary"|| reptType==="mealRefusedReport" || reptType==='upliftAuditReport'){
        setStoreType([e])

    }
    else{
        setStoreType([e])

    }
}
const onColumnResizedHandler=(e)=>{

  if (e && e.column?.getColId() === 'sectors') {
    const newWidth = e?.column.actualWidth;

    const sectorCells = document.querySelectorAll('.sector-container');
    sectorCells.forEach(cell => {
      cell.style.maxWidth = `${newWidth}px`;
    });
  }
}
const handleAddInstance=()=>{
setModalFormStatusObj({text:""})
}
  const onDateChange=(e)=>{
    setState( (_prev) => {
        return { ..._prev,startDate:e.target.value,resetDataSource:!state.resetDataSource}
      });
  }
const onDateChangeRep=(e)=>{
const {name,value}=e.target;
if(name==='startDate'){
    setReportDate((prev)=>({...prev,startDate:value}))
}
else{
    setReportDate((prev)=>({...prev,endDate:value}))
}
}
  const onInstanceChange=(e)=>{
    setState( (_prev) => {
        return { ..._prev,instanceChange:e.target.value,resetDataSource:!state.resetDataSource}
      });
  }

  const onSearchSectors=(e)=>{
    setState( (_prev) => {
        return { ..._prev,sectors:e.target.value,resetDataSource:!state.resetDataSource}
      });
  }
const onInstanceStateChange=(e)=>{
  const {value}=e?.target;
  const excludeNil = value === 'excludeNilInstance';
   setState( (_prev) => {
        return { ..._prev,...(excludeNil?{InstanceState:value,emptInst:true}:{InstanceState:value,emptInst:false}),resetDataSource:!state.resetDataSource}
      });
}
  const onUploadClose = () => {
    setShowDownload(false);
    setReportDate({startDate:"",endDate:""})
    setReptType("");
    setStoreType([]);
  }
  const onChangeTailNumber=(e)=>{
    setState( (_prev) => {
        return { ..._prev,tailNum:[e],resetDataSource:!state.resetDataSource}
      });
  }

const orderListChange={
  status,
  setStatus,
 paymentType, setPaymentType,inventoryDetails,
saleType, setSaleType,
searchKeyOrders, setSearchKeyOrders,
saleTypeCheck,setSaleTypeCheck
}

  return (
      <div className="op-aircraft-container flexCol full-flex ag-theme-alpine-dark">
      {
        <>

          <div className="flexRow justifyContentFlexEnd alignItemsCenter margRight margBot10">
          {
          Boolean(state.message) &&
          <div className={`validationMsgDiv error`}>
            {state.message.text}
          </div>
        }
          </div>

          <div className="flexRow gap10 width100 justifyContentFlexStart alignItemsCenter">
            <div>
            <input className="edit-input-synced-search" onChange={onInstanceChange} type="search" placeholder=" Search Instance Name" value={state.instanceChange||null}/>
            </div>

            {state && state.tailNum? (<div className='felxCol' style={{marginBottom:'0.2rem'}}>
            <Select
              options={tailNumbers}
              defaultValue={state.tailNum[0]?.label ? state.tailNum[0]?.label : ''}
              value={tailNumbers?.filter(function (option) {
                return (
                  state.tailNum.length && state.tailNum[0]&&
                  state.tailNum.find((sc) => sc.label === option.label)
                );
              })}
              onChange={onChangeTailNumber}
              styles={customSelSearch(themedColor)}
              isOpenMenu={state.isOpenMenu}
              placeholder="Search Tail Number"
              isSearchable={true}
              isClearable={true}
              className="selectMenu-meals"
            />
          </div>):<></>}

            <button className="orderStatus-div">
            <>
                    <NGODatePicker
                      style={{width: '13rem',border:'0.7px solid #fff'}}
                      value={state.startDate?new Date(state.startDate):""}
                      dateFormat="dd/MM/yyy"
                      name='startDate'
                      className="input-margin"
                      isclearable={true}
                      placeholder={t('Start Date')}
                      placeholdertext={t('datePickerPlaceholder')}
                      onChange={onDateChange} />
                  </>
            </button>

            <button className="saleType-div">
              <select
                className="select-item darkBlue-bg"
                onChange={onInstanceStateChange}
                value={state.InstanceState}
                id="saleTypeId"
              >
                <option key="" value="">
                 Instance State
                </option>
                {InstanceState.map((_,index) => {
                  return (
                    <option key={index} value={_.value}>
                      {_.label}
                    </option>
                  );
                })}
              </select>
            </button>

            <div>
            <input className="edit-input-synced-search" onChange={onSearchSectors} type="search" placeholder="Search Sectors" value={state.sectors||null}/>
            </div>
            {downloadInstances ? <div title="Download Reports" className="flexRow justifyContentCenter alignItemsCenter margTop8">
              <button className='download dropdownStyle1-TextMedium' onClick={onDownloadReport}><span><img className={`download__banner_${isDownloading ? "active" : "icon-size mt-1"}`} alt='downloadMaster' src={downloadMasterIcon} /></span></button>
          </div>:<></>}
          { createInstances && <div className="flexRow width100 justifyContentFlexEnd">
            <button className="add-item-button" onClick={ onAddItemHandler }>
                 + Instance
                  </button>
            </div>}
          </div>
              <ToastContainer />
          <DataGrid
            ref={tableRef}
            className="full-flex"
            columns={[...Columns]}
            initialPageLimit={perPageLimit}
            showDefaultFilters={false}
            searchKey={searchKey}
            noResultsMessage={""}
            onColumnResizedHandler={onColumnResizedHandler}
            selItemType={selItemType}
            getRows={fetchOperationsPanel}
            getRowHeight={getRowHeight}
            rowSelection="multiple"
            onAddItemHandler={() => onAddItemHandler()}
            columnResize={true}
            resetDataSource={state.resetDataSource}
          />
        </>
      }

{
       state&&state.selected === 'createInstance' &&
        <EditModal
          showDone={true}
          className='cash-sector-add'
          showFieldsInColumn={true}
          disabled={state.disabled}
          customContentHeight={ModalContHeight}
          setIsDropdownOpen={setIsDropdownOpen}
          modalFormStatusObj={modalFormStatusObj}
          title={"Create Instance"}
          buttonLabel={"Create"}
          fields={
            EditFormFields.map((elt) => {
              return { ...elt}
            })
          }
          onChange={handleAddInstance}
          onSubmit={handleCreateInstance}
          onClose={handleModalCancel}>
        </EditModal>
      }

{
       state&&state.selected&&state.selected.action === 'sectorAttachments' &&
        <Modal
        className='cash-deposit-summary'
        title={``}
        TitleComponent={sectorTitle}
        onSubmit={()=>handleModalCancel('Sectattach')}
        onClose={()=>handleModalCancel('SectAttach')}>
        {<SectorInstanceCard eventLogs={showEventLogs} inventoryDetails={inventoryDetails} reload={reload} header={state.selected}/> }
      </Modal>
      }

{
       state&&state.selected2&&state.selected2.action === 'viewEventLogs' &&
        <Modal
        className='cash-deposit-summary'
        title={``}
        TitleComponent={sectorTitle}
        onSubmit={handleModalCancelEvent}
        onClose={handleModalCancelEvent}>
        {<EventLogContainer id={null} reload={reload} data={state.selected2.data}/> }
      </Modal>
      }

{
       state && state.selected && state.selected2 && state.selected2.action === 'orders' &&
        <Modal
        className='cash-deposit-summary'
        title={``}
        TitleComponent={sectorTitle}
        onSubmit={handleModalCancelEvent}
        onClose={handleModalCancelEvent}>
        {<OrderListing id={null} {...orderListChange} reload={reload} dataOrder={{...state.selected2,label:state?.data||{},state:state?.InstanceState,timeZone:getCultureFromLs()?.timezone?.name}}/> }
      </Modal>
      }

{
       state && state.selected2 && state.selected2?.data && (state.selected2.action === 'transferOut'||state.selected2.action === 'transferIn'||state.selected2.action==='upliftAudit'|| state.selected2.action === 'stockMovement'||state.selected2.action === 'uplifts') &&
        <Modal
        className='cash-deposit-summary'
        title={``}
        overlayClassName={state.selected2.action === 'stockMovement' ? 'overlay-e1' : ''}
        customModalStyle={state.selected2.action === 'stockMovement' ? { width: '91.5%' } : {}}
        TitleComponent={sectorTitle}
        onSubmit={handleModalCancelEvent}
        onClose={handleModalCancelEvent}>
          <div className='flexCol full-flex'>
             <div className='fitcontent justifyContentSpaceBetween display wrapper-sector-dynamic'>
              <div className='flexRow sector-banner display justifyContentSpaceBetween'>
                <div className='flexRow justifyContentFlexStart'>
                   <div className='sector-number fontMedium'>{state.selected2.data.sector?.flightNumber ?? state.selected2.flightDetails?.flightNumber}</div>
                   <div className='flexCol justifyContentCenter alignItemsCenter'>
                <div className='flexRow sector-tag'>{state.selected2.data.sector?.origin ?? state.selected2.flightDetails?.origin}</div>
                <div className='flexRow fontMedium'>{state.selected2.data.sector?.originName ?? state.selected2.flightDetails?.originName}</div>
                </div>
                </div>

                <div className='flexCol justifyContentCenter alignItemsCenter'>
                <div className='flexRow'> <IoArrowForwardOutline size={17} color={'#F06548'}/></div>
                <div className='flexRow fontMedium'>{moment.parseZone(formatDateByTimezone(state.selected2.data.sector?.flightDate ?? state.selected2.flightDetails?.flightDate)).format('DD-MM-YYYY')}</div>

                </div>
               <div className='flexCol justifyContentCenter alignItemsCenter'>
                <div className='flexRow sector-tag'>{state.selected2.data.sector?.destination ?? state.selected2.flightDetails?.destination}</div>
                <div className='flexRow fontMedium'>{state.selected2.data.sector?.destinationName ?? state.selected2.flightDetails?.destinationName}</div>
                </div>
              </div>
              </div>
              <DataGrid
            rowData={state.selected2.action === 'transferIn'?state?.selected2.data?.items??[]:state.selected2.action === 'transferOut'?state?.selected2.data?.items??[]:state.selected2.action === 'uplifts'?state?.selected2.data?.items??[]:state.selected2.action === 'upliftAudit'?state?.selected2.data?.items??[]:state?.selected2.data?.items??[]}
            columnResize
            ref={tableRef}
            className='full-flex'
            showDefaultFilters={false}
            enableGridSearch={false}
            columns={(state.selected2.action === 'transferIn'||state.selected2.action==='transferOut')?TransferIn:state.selected2.action==='uplifts'?Uplifts:state.selected2.action==='upliftAudit'?UpliftAudit:StockMvmnt}
            rowModelType='clientSide'
            />
            {state.selected2.action!=="stockMovement" && state?.selected2.data?.items?.length?  <div className='flexRow fitContent'>
                  <div style={{float:'left'}} className="  margTop10 flexCol width50 justifyContentFlexStart">

                  <div className='margBottom10'>
                  <label className='fontExtrabold'>Created At</label>
                  <div>{moment(state.selected2.data?.createdAt).tz(getCultureFromLs()?.timezone.name).format('DD-MM-YYYY hh:mm A')}</div>
                </div>

                <div className='margBottom10'>
                  <label className='fontExtrabold'>Created By</label>
                  <div className='flexCol'>
                  <div className='flexRow'>
                  {state.selected2.data?.createdBy?.employeeName}
                    </div>
                    {state.selected2.data?.createdBy?.employeeName && state.selected2.data?.createdBy?.employeeCode &&state.selected2.data?.createdBy?.employeeName !== state.selected2.data?.createdBy?.employeeCode?  <div className='flexRow'>
                    {state.selected2.data?.createdBy?.employeeCode}
                    </div>:null}
                    </div>
                </div>
                <div className='margBottom10'>
           {  state.selected2.action!=='uplifts' && state.selected2.action!=="stockMovement" && state?.selected2.data?.items?.length ?<><label className='fontExtrabold'>Created Using</label>
                  <div className='flexCol'>
                  <div className='flexRow'>
                  {state.selected2.data?.userAgent?.appName}@ {state.selected2.data?.userAgent?.appVersion}
                    </div>
                    <div className='flexRow'>
                    {state.selected2.data?.userAgent?.deviceModel},{state.selected2.data?.userAgent?.macId ? `MAC ID: ${state.selected2.data?.userAgent?.macId}` : state.selected2.data?.userAgent?.deviceName}

                    </div>
                    </div></>:<><label className='fontExtrabold'>Warehouse</label>
                  <div className='flexCol'>
                  <div className='flexRow'>
                  {state.selected2.flightDetails?.warehouse?.warehouseCode}
                    </div>

                    </div></> }
                </div>
              </div>



              </div>:<></>}
          </div>
      </Modal>
      }


    {
    state&&state.selected2&&state.selected2.action === 'salesSummary' &&
    <SalesSummary sectorTitle={sectorTitle} handleModalCancelEvent={handleModalCancelEvent} state={state} paymentTypeDist={paymentTypeDist} saleTypeDist={saleTypeDist} currencyDist={currencyDist} />
    }


     {showDownload &&
        <div className="overlay" role="dialog">
          <div className="dialog sm-scrollbar">
            <div className="dialog__content">
              <div className='dialog-header flexRow alignItemsCenter width100 content-tabs'>
                <h2 className="dialog__title subheading-text-medium fontMedium justifyContentCenter alignItemsCenter margBottom0 width50">Download reports</h2>
              <button className='close-btn-ht' onClick={onUploadClose}>
                <img src={closeIcon} alt="close" data-icon='close'/>
              </button>
             </div>
              <hr />
                <div className="dialog__body_container flexRow mt-4 button-align justifyContentCenter flexWrap">
                <div className={`dialog__container_item input-container`}>
                 <div className={`dialog__description`}>
                <label className={`fontRegular req mt-2 menuLeft`}>Report Type</label>
                  <select className='select-input-galley1'
                  onChange={onReportTypeChange}
                  >
                    {reportsType.map((_) => {
                      return (
                        <option value={_.value} key={_.value}>{_.label}</option>
                      )
                    })}
                  </select>

                <div className={`dialog__container_item input-container`}>
                <div className={`dialog__description`}>
         {     reptType!=='activityReport'? <><> <label className={`fontRegular req menuLeft`}>Start Date</label>
                    <NGODatePicker
                      style={{width: '17rem'}}
                      value={reportDate.startDate}
                      name="startDate"
                      isclearable={true}
                      placeholder={t('Start Date')}
                      placeholdertext={t('datePickerPlaceholder')}
                      onChange={onDateChangeRep} />
                  </>
                  <> <label className={`fontRegular req menuLeft`}>End Date</label>
                    <NGODatePicker
                      style={{width: '17rem'}}
                      value={reportDate.endDate}
                      name="endDate"
                      isclearable={true}
                      maxDate={getEndDateMaxLimit(reportDate?.startDate)}
                      placeholder={t('End Date')}
                      placeholdertext={t('datePickerPlaceholder')}
                      onChange={onDateChangeRep} />
                  </></> :<></>}
             { reptType==="sandboxSalesSummary"|| reptType==="sandboxInvoiceSummary" || reptType==="mealRefusedReport" || reptType==='upliftAuditReport'?  <>
          
               <label className={`fontRegular mt-2 mb-2 textAlignLeft`}>Select Route</label>
               <Select
             options={stores}
             value={stores?.filter(function (option) {
               return (
                 storeType.length && storeType[0]&&
                 storeType.find((sc) => sc.label === option.label)
               );
             })}
             onChange={onStoreChange}
             styles={customStyles}
             placeholder="Select Route"
             isSearchable={true}
             isClearable={true}
           />
             </> :<></>
             } </div>
             </div>
                <button type="button" onClick={onDownloadReport} disabled={state.disabled} className="btn btn-info mt-4" style={{ color: "white",width:"100%" }}>
                  { isDownloading?<div className='flexRow justifyContentCenter alignItemsCenter'><img src={LoadingGIF} className='icon-size' style={{width:'25px',height:'25px'}} alt="Loading" /> Processing...</div>:<span><span><img className="icon-size mt-1" alt='downloadMaster' src={downloadMasterIcon} /></span> Download</span>}
                </button>
              </div>
</div>

                </div>
            </div>
          </div>
        </div>
      }
      {
     !ready &&<div className='overlay_hide sub'></div>
      }
    </div>
  )
}